import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-decisionsend",
  templateUrl: "decisionsend.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DecisionSendComponent implements OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @Input() texts: any;
  @Input() status: string;
  @Input() preventValidation: boolean;
  @Output() clickButton: EventEmitter<string> = new EventEmitter();
  @Output() releaseDecisionButton: EventEmitter<string> = new EventEmitter();

  subs = new SubSink();
  cssColor: string;
  logoImage: string;
  isDemo = false;
  decisionReadonly: boolean;
  canRelease: boolean;

  constructor(
    private configurationService: ConfigurationService,
    private viewContainerRef: ViewContainerRef,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        if (c.highContrast) {
          thisObject.logoImage = `img/${c.cssColor}-validate-ready-hc.png`;
        } else {
          thisObject.logoImage = `img/${c.cssColor}-validate-ready.png`;
        }
        thisObject.isDemo = c.isDemo;
        thisObject.decisionReadonly = c.isDecisionReadOnly;
        thisObject.canRelease = c.canReleaseDecision;
      },
    );
  }

  onclick() {
    if (this.decisionReadonly)
      this.releaseDecisionButton.emit("button clicked");
    else this.clickButton.emit("button clicked");
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
